type DocsPathMapping = {
  pathPrefix: string;
  docsLink: string;
};

export const DOCS_PATH_MAPPINGS: DocsPathMapping[] = [
  // IO Intelligence
  { pathPrefix: "/ai/app/new", docsLink: "guides/intelligence/unified-chat" },
  { pathPrefix: "/ai/models", docsLink: "guides/intelligence/exploring-ai-models" },
  { pathPrefix: "/ai/agents", docsLink: "guides/intelligence/exploring-ai-agents" },
  {
    pathPrefix: "/ai/agentic-workflow-editor",
    docsLink: "guides/intelligence/agentic-workflow"
  },
  { pathPrefix: "/ai/training", docsLink: "guides/intelligence/training-as-a-service" },
  {
    pathPrefix: "/ai/api-keys",
    docsLink: "guides/intelligence/api-keys-and-secrets"
  },
  {
    pathPrefix: "/id/account/intelligence",
    docsLink: "guides/payment/io-intelligence-payments"
  },

  // IO Cloud
  { pathPrefix: "/cloud/home", docsLink: "guides/clouds/start-using-io-cloud" },
  { pathPrefix: "/cloud/container", docsLink: "guides/clouds/deploy-containers" },
  { pathPrefix: "/cloud/clusters", docsLink: "guides/clouds/deploy-ray-cluster" },
  {
    pathPrefix: "/cloud/bare-metal",
    docsLink: "guides/clouds/deploy-bare-metal-cluster"
  },
  {
    pathPrefix: "/cloud/virtual-machines",
    docsLink: "guides/clouds/deploy-vm-on-demand"
  },
  {
    pathPrefix: "/cloud/kubernetes",
    docsLink: "guides/clouds/deploy-kubernetes-cluster"
  },

  // IO Worker
  { pathPrefix: "/worker/devices/explorer", docsLink: "guides/explorer/workers-page" },
  { pathPrefix: "/worker/dashboard/devices", docsLink: "guides/workers/intro" },
  { pathPrefix: "/worker/dashboard/staking/devices", docsLink: "guides/staking/io-staking" },
  {
    pathPrefix: "/worker/dashboard/earnings-and-rewards",
    docsLink: "guides/workers/earnings-rewards"
  },

  // IO Explorer
  { pathPrefix: "/explorer/home", docsLink: "guides/explorer/homepage" },
  { pathPrefix: "/explorer/transactions", docsLink: "guides/explorer/tne-on-chain" },
  { pathPrefix: "/explorer/inferences", docsLink: "guides/explorer/inferences-page" },
  { pathPrefix: "/explorer/clusters", docsLink: "guides/explorer/clusters-page" },
  {
    pathPrefix: "/explorer/staking-dashboard",
    docsLink: "guides/explorer/staking-dashboard"
  },
  {
    pathPrefix: "/explorer/block-rewards",
    docsLink: "guides/explorer/block-rewards-page"
  },
  { pathPrefix: "/explorer/map", docsLink: "guides/explorer/network-map-page" },

  // IO ID
  { pathPrefix: "/id/account/overview", docsLink: "guides/id/io-id" },
  { pathPrefix: "/id/account/io-cloud", docsLink: "guides/id/usage-and-billing" },
  { pathPrefix: "/id/account/settings", docsLink: "guides/id/managing-your-wallets-in-io-id" },
  { pathPrefix: "/id/funds", docsLink: "guides/id/usage-and-billing" },
  {
    pathPrefix: "/id/account/acknowledgment",
    docsLink: "guides/id/io-id#user-acknowledgment"
  },

  // IO Staking
  {
    pathPrefix: "/staking/co-staking-marketplace",
    docsLink: "guides/staking/io-staking"
  },
  {
    pathPrefix: "/staking/my-co-staking",
    docsLink: "guides/staking/view-co-staking-device"
  }
];
